export const AgGridFiltersController = (
  $scope,
  $uibModal,
  $log,
  logger,
  $rootScope,
  GridApi
) => {
  $scope.openSaveFilterModal = () => {
    $scope.filterOptions = {
      saveFilter: $scope.gridName !== 'MatchingLawyers',
      saveColumnSetting: true,
      currentPositionInGrid: true,
      sorting: true,
      gridName: $scope.gridName,
    }

    const saveRulesModalInstance = $uibModal.open({
      templateUrl: 'add-filters-modal.html',
      windowClass: 'builder-save-dialog', // This property adds the class "builder-save-dialog" to the modal container
      controller: 'AddAgGridFiltersController',
      controllerAs: 'ctrl',
      resolve: {
        filterOptions: function() {
          return $scope.filterOptions
        },
        gridOptions: function() {
          return $scope.gridOptions
        },
      },
    })
    saveRulesModalInstance.result.then(
      newFilter => {
        $scope.savedFilters.push(newFilter)
      },
      () => errorHandler
    )
  }

  const errorHandler = errorResponse =>
    $log.info(
      'An Error occurred while trying to make an API call. Please find further details in this object:',
      errorResponse
    )

  $scope.setFilter = selectedFilter => {
    $scope.setFilterOnGrid({selectedFilter: selectedFilter})
  }

  $scope.setDefaultViewFilter = async (filter, isDefault, event) => {
    event.stopPropagation()
    const payload = {
      filterId: filter.id,
      gridId: $scope.gridName,
      isDeleted: !isDefault,
    }

    $scope.savedFilters.map(row => {
      row.default = false
      return row
    })
    try {
      const {status} = await GridApi.editDefaultGridFilter(
        $rootScope.user.id,
        payload
      )
      if (status === 200) {
        if (isDefault) {
          logger.notify('success', `New Default View created!`)
          $scope.savedFilters.find(
            row => row.id === filter.id
          ).default = isDefault
          $scope.$apply()
        } else logger.notify('success', `Removed Default View !`)
      }
    } catch (error) {
      errorHandler(error)
    }
  }

  $scope.expandCollapseGrid = () => {
    if ($scope.gridOptions.groupDefaultExpanded < 2) {
      $scope.gridOptions.api.collapseAll()
      $scope.gridOptions.groupDefaultExpanded = 2
    } else if ($scope.gridOptions.groupDefaultExpanded === 2) {
      $scope.gridOptions.groupDefaultExpanded = -1
      $scope.gridOptions.api.expandAll()
    }
  }

  $scope.resetColumnGrid = () => {
    $scope.gridOptions.columnApi.setColumnState($scope.getColumnStateValue)
  }

  $scope.openDeleteFilterModal = (type, filter, event) => {
    event.stopPropagation()
    if (filter.isPublic) {
      logger.notify(
        'warning',
        'Are you sure you want to delete this Saved View?'
      )
    }

    const deleteModalInstance = $uibModal.open({
      templateUrl: 'delete-filters-modal.html',
      controller: 'DeleteAgGridFiltersController',
      controllerAs: 'ctrl',
      resolve: {
        filter: function() {
          return filter
        },
        type: function() {
          return type
        },
      },
    })
    deleteModalInstance.result.then(
      () => {
        $scope.savedFilters.splice(_.findIndex($scope.savedFilters, filter), 1)
      },
      () => {}
    )
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/ag-grid-filters/filters.ctrl.js